export default __webpack_public_path__ + "static/media/irrigationmanagement.4066f56a.png";